<template>
  <div class="switch-wrap d-flex w-80px align-center">
    <div class="switch mr-10px" :class="switchClassObj" @click="toggleSwitch">
      <div class="switch-circle" :class="{ open: isOpen }"></div>
    </div>
    <div class="switch-text h5" :class="{ open: isOpen }">
      {{ isOpen ? showText.open : showText.close }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [Boolean, Number],
      default: false,
    },
    switchColorClass: {
      type: String,
      default: 'success-500',
    },
    showText: {
      type: Object,
      default: () => ({
        open: '顯示',
        close: '隱藏',
      }),
    },
  },
  computed: {
    isOpen() {
      return this.value;
    },
    switchClassObj() {
      const { switchColorClass } = this;
      const template = { open: this.isOpen, [switchColorClass]: this.isOpen };
      return template;
    },
  },
  methods: {
    toggleSwitch() {
      this.$emit('input', !this.isOpen);
      this.$emit('changeStatus');
    },
  },
};
</script>

<style lang="scss" scoped>
.switch {
  position: relative;
  display: flex;
  align-items: center;
  width: 40px;
  height: 24px;
  background: #848fa0;
  border-radius: 15px;
  cursor: pointer;
  &.open {
    background-color: #88c640;
  }

  &-circle {
    position: absolute;
    width: 20px;
    height: 20px;
    top: 50%;
    transform: translateY(-50%);
    left: 5%;
    border-radius: 50%;
    background-color: #fff;
    transition: all 0.3s;
    &.open {
      left: 95%;
      transform: translateX(-100%) translateY(-50%);
    }
  }

  &-text {
    color: #848fa0;
    &.open {
      color: #353e4d;
    }
  }
}
</style>
